window.addEventListener('turbo:load', () => {
  const progressBar = document.querySelector('[data-name="js-progress"]');
  if (progressBar) {
    const progressHeight = progressBar.clientHeight;
    document.body.style.paddingBottom = `${progressHeight}px`;
  }
});
